import React from 'react';
import { IntlProvider } from 'react-intl';
import i18n, { IntlCapture } from 'src/i18n';
import App from 'client/app';
import routes from 'routes/routes';

export default class LocaleWrapper extends React.Component {
  constructor(props) {
    super(props);

    this.state = { 'locale': i18n.locale };

    this.setUpHandlers();
  }

  /**
   * Binds any handlers to the correct context
   *
   * @method  setUpHandlers
   */

  setUpHandlers() {
    this.onLocaleChange = this.handleLocaleChange.bind(this);
  }

  /**
   * Handles updating the locale based on user selection
   * @method handleLocaleChange
   * @param locale - The new locale value to store
   */
  handleLocaleChange(locale) {
    i18n.setActiveLocale(locale);
    this.setState({ 'locale': locale });
  }

  render() {
    return (
      <IntlProvider locale={i18n.locale} key={i18n.locale} messages={i18n.getLocaleMessages()}>
        <IntlCapture>
          <App routes={routes} onLocaleChange={this.onLocaleChange} />
        </IntlCapture>
      </IntlProvider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/client/locale-wrapper.jsx